jQuery(document).ready(function () {
  var $ = jQuery;
  var caseStudySliders = $(".case-study .case-study-slider");
  $(caseStudySliders).each(function () {
    var sliderNav = $(this).siblings(".case-study-nav");
    var dropdownNav = $(this).siblings(".case-study-nav-select").find("select");

    // Slick
    $(this).on("init", function () {
      $(".case-study-tab:nth-child(1)", sliderNav).addClass("active");
      positionArrows();
    });

    var slider = $(this).slick({
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><span class="arrowIcon"></span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="arrowIcon"></span></button>',
    });

    $(slider).on("swipe", function (event, slick, direction) {
      var slideIndex = $(slider).slick("slickCurrentSlide");
      switch (direction) {
        case "left":
          $($("option", dropdownNav)[slideIndex]).attr("selected", "selected");
          slideIndex += 1;
          break;
        case "right":
          if (slideIndex == 0) {
            $($("option", dropdownNav)[1]).attr("selected", "selected");
            slideIndex = 1;
          } else {
            $($("option", dropdownNav)[slideIndex]).attr(
              "selected",
              "selected"
            );
            slideIndex += 1;
          }
          break;
      }
      $(".case-study-tab", sliderNav).removeClass("active");
      $(".case-study-tab:nth-child(" + slideIndex + ")", sliderNav).addClass(
        "active"
      );
    });

    $(slider).on("afterChange", function (event, slick, currentSlide) {
      positionArrows();
    });

    // Nav click
    $(".case-study-tab", sliderNav).click(function () {
      var clickedTab = $(this);
      var clickedTabIndex = $(clickedTab).index();
      $(".case-study-tab", sliderNav).removeClass("active");
      $(clickedTab).addClass("active");
      $(slider).slick("slickGoTo", clickedTabIndex);
      $($("option", dropdownNav)[clickedTabIndex]).attr("selected", "selected");
    });

    // Arrow click
    $(".slick-arrow", slider).click(function () {
      var slideIndex = $(slider).slick("slickCurrentSlide");
      switch ($(this).hasClass("slick-next")) {
        case true:
          $($("option", dropdownNav)[slideIndex]).attr("selected", "selected");
          slideIndex += 1;
          break;
        case false:
          if (slideIndex == 0) {
            $($("option", dropdownNav)[1]).attr("selected", "selected");
            slideIndex = 1;
          } else {
            $($("option", dropdownNav)[slideIndex]).attr(
              "selected",
              "selected"
            );
            slideIndex += 1;
          }
          break;
      }
      $(".case-study-tab", sliderNav).removeClass("active");
      $(".case-study-tab:nth-child(" + slideIndex + ")", sliderNav).addClass(
        "active"
      );
    });

    // Dropdown
    $(dropdownNav).change(function () {
      var index = $(this)[0].selectedIndex;
      $(slider).slick("slickGoTo", index);
      $($(".case-study-tab", sliderNav)[index]).click();
    });

    $(window).resize(function () {
      setTimeout(function () {
        positionArrows();
      }, 80);
    });

    function positionArrows() {
      var width = window.innerWidth;
      if (width < 640) {
        var textContainerHeight = $(
          ".slick-current .case-study-slide-text",
          slider
        ).outerHeight(true);
        $(".slick-arrow", slider).css("top", textContainerHeight - 80);
      } else {
        $(".slick-arrow", slider).css("top", "50%");
      }
    }
  });
});
